import * as React from 'react';
import { Avatar } from '@mui/material';
import { useRelativeConditionIndexDetail } from '../../data/DataProviders/RelativeConditionIndexProvider';
import { isDataLoaded } from '../../types'
import { useStyles } from '../RelativeConditionIndex/styles';

export const ConditionIndexBadge: React.FC = () => {
    const responseData = useRelativeConditionIndexDetail();
    const classes = useStyles();
    const d = new Date();
    d.setMonth(d.getMonth() - 1);
    const t = d.toDateString().split(' ');     
    const monthAndyear = `${t[1]} ${t[3]}`;
  
    let rankColors, rankPercentage;
    if (isDataLoaded(responseData)) {
        responseData.value.data.map((item) => {
            if (item.monthAndYear === monthAndyear) {
                rankColors = item.rankColor;
                rankPercentage = item.rankPercentage === '--' ? (<>--</>) : <>{Number(item.rankPercentage).toFixed()}%</>                
            }else{
                rankColors='Grey';
                rankPercentage = '--';
            } 
        });
    }
    const conditionStyle = (rankColor: any, cls: any): void => {
        switch (rankColor) {
            case 'Yellow':
                return cls.Yellow;
            case 'Red':
                return cls.Red;
            case 'Green':
                return cls.Green;
            case 'Grey':
                return cls.Grey;
            default:
        }
    };
    return (
        <div className={classes.positionDiv}>
            <span className={classes.badgeAlign}>
                {isDataLoaded(responseData) && (
                    <>
                        {responseData.value.data.length > 0 && (                           
                                <Avatar className={`${classes.relAvatar} ${conditionStyle(rankColors, classes)}`}>
                                    {rankPercentage}
                                </Avatar>                           
                        )}
                    </>
                )}
            </span>
        </div>
    );
};
